<div class="generic-cfl">
    <h2 mat-dialog-title class="dialog-title text-center fs-5">{{this.data.title}}</h2>

    <mat-dialog-content class="mat-typography">

        <div class="row">
            <div class="col-md-12 tabledesign p-0">
                <!-- <app-chip [filterItems]='selectedFilters' (removeFilter)="onRemoveChipCFL($event.index,$event.data)">
                </app-chip> -->
                <!-- <div class="example-container cfl-table mat-elevation-z8" (scroll)="onTableScroll($event)">
                     -->
                <div class="cfl-table">
                    <table mat-table #compGenericVFTbl [dataSource]="this.dataSource">

                        <ng-container [matColumnDef]="col" *ngFor="let col of this.displayColumnList">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-color">
                                {{getActualString(col != "#" ? col: 'Select')}}
                            </th>

                            <ng-container *ngIf="col == '#'">
                                <td mat-cell *matCellDef="let element;let i = index" >
                                    <ng-container [ngSwitch]="this.data.title">
                                        <mat-radio-button [value]="element" *ngSwitchCase="'Main HSN'"
                                            [checked]="this.data.selectedIndex == element.Chapter"
                                            (change)="selectItem(element)"></mat-radio-button>
                                        <mat-radio-button [value]="element" *ngSwitchCase="'Transporter'"
                                            [checked]="this.data.selectedIndex == i"
                                            (change)="selectItem(element)"></mat-radio-button>    
                                        <mat-radio-button [value]="element" *ngSwitchDefault
                                            [checked]="this.data.selectedIndex == element.Name"
                                            (change)="selectItem(element)"></mat-radio-button>
                                    </ng-container>
                                </td>
                            </ng-container>    

                            <ng-container *ngIf="col !== '#'">
                                <td mat-cell *matCellDef="let element;" >
                                    <span style="line-height: 0;">{{element[col]}}</span>
                                </td>
                            </ng-container>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="this.displayColumnList; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: this.displayColumnList;"></tr>
                    </table>
                </div>
            </div>
        </div>
        <!-- </div> -->

    </mat-dialog-content>
    <mat-dialog-actions align="end" class="dialog-actions">
        <button mat-stroked-button color="primary" [mat-dialog-close]="true">Cancel</button>
    </mat-dialog-actions>
</div>